import * as React from 'react';
import { Box, Group, Button, Textarea, TextInput, Select } from '@mantine/core'
import  { useForm, isNotEmpty } from "@mantine/form";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { showMessage } from "../../lib/notification";
import { APIClient, apiClients } from "./constants";
import type { IResponse } from "../../types/api";
import type { INotification } from "./types";
import Page from "../../components/layout/Page";
import { useFormStyles } from "../../styles/form";

interface FormValues extends Pick<INotification, 'title' | 'body' |  'topic'> {
    apiClient: APIClient;
}

const CreateCategory = () => {

    const { classes } = useFormStyles();
    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            topic: 'all',
            apiClient: 'duul',
            body: '',
            title: ''
        },
        validate: {
            title: isNotEmpty('Гарчиг оруулна уу'),
            body: isNotEmpty('Контент оруулна уу'),
            topic: isNotEmpty('Topic оруулна уу'),
            apiClient: isNotEmpty('Апп сонгоно уу'),
        },
    });

    const handleSubmit = async (values: FormValues) => {
        const { data } = await axios.post<IResponse<any>>(API_ROUTE, values);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green');
        } else {
            showMessage('Алдаа гарлаа');
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} үүсгэх`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto" my={'xl'}>
                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>

                        <Select
                            withAsterisk
                            data={apiClients}
                            label={'Апп'}
                            {...form.getInputProps('apiClient')}
                        />

                        <TextInput
                            withAsterisk
                            label="Гарчиг"
                            placeholder="Гарчиг оруулна уу"
                            {...form.getInputProps('title')}
                        />

                        <Textarea
                            withAsterisk
                            autosize
                            label="Контент"
                            placeholder="Контент..."
                            minRows={4}
                            {...form.getInputProps('body')}
                        />
                    </form>
                </Box>
                <Page.Footer>
                    <Group position="right" mt="md">
                        <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                    </Group>
                </Page.Footer>
            </Page.Body>
        </Page>
    );
};

export default CreateCategory;